import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-rail-engineering-technician',
  templateUrl: './rail-engineering-technician.component.html',
  styleUrls: ['./rail-engineering-technician.component.scss']
})
export class RailEngineeringTechnicianComponent implements OnInit {


  @Input('job') singleJob;
  @Input('learner') singleLearner;
  @Input('assessment') assessmentEdit;
  // singleLearner: any;
  jobData
  learnerData
  assesmentCheckListFormEdit: any;
  user
  jobId

  constructor() { }

  ngOnInit() {
  }


  ngOnChanges(changes: SimpleChanges): void {
    console.log("changes of job and learner data", changes);
    if (changes.singleJob && changes.singleJob.currentValue) {
      this.jobData = changes.singleJob.currentValue
      this.jobId = this.jobData[0]._id
      console.log("instructorsList ====== instructorsList", this.jobData);

    }

    if (changes.singleLearner && changes.singleLearner.currentValue) {
      this.learnerData = changes.singleLearner.currentValue
    }

    if (changes.assessmentEdit && changes.assessmentEdit.currentValue) {
      this.assesmentCheckListFormEdit = changes.assessmentEdit.currentValue
    }

  }

}
